var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2691,
	"./chat-icon-bottom-nav-mobile.webp": 2692,
	"./home-icon-bottom-nav-mobile-active.webp": 2693,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2694,
	"./home-icon-bottom-nav-mobile.webp": 2695,
	"./home-icon-bottom-nav-mobile_b.webp": 2696,
	"./me-icon-bottom-nav-mobile-active.webp": 2697,
	"./me-icon-bottom-nav-mobile.webp": 2698,
	"./promo-icon-bottom-nav-mobile-active.webp": 2699,
	"./promo-icon-bottom-nav-mobile.webp": 2700,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2701,
	"./sponsor-icon-bottom-nav-mobile.webp": 2702,
	"./stream-icon-bottom-nav-mobile-active.webp": 2703,
	"./stream-icon-bottom-nav-mobile.webp": 2704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2690;